import { Pipe, PipeTransform } from '@angular/core';
      
      @Pipe({
    name: 'listOptionToDisplayValue',
    standalone: false
})
      export class ListOptionToDisplayValuePipe implements PipeTransform {
          transform(value: any, property: string = 'displayName'): string {
      
              if(!value)
                  return '';
      
              if (Array.isArray(value)) {
                  return value.length > 0 ? value.map(x => x[property]).join(', ')  : '';
              }
              else{
                  return value[property];
              }        
          }
      }